import script from "./ComputerScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ComputerScreen.vue?vue&type=script&setup=true&lang=js"

import "./ComputerScreen.vue?vue&type=style&index=0&id=40f06846&lang=css"

const __exports__ = script;

export default __exports__